import { render, staticRenderFns } from "./ClientElement.vue?vue&type=template&id=3334034e&scoped=true&"
import script from "./ClientElement.vue?vue&type=script&lang=js&"
export * from "./ClientElement.vue?vue&type=script&lang=js&"
import style0 from "./ClientElement.vue?vue&type=style&index=0&id=3334034e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334034e",
  null
  
)

export default component.exports